import API from './API'

export default {
  // Log an event. Extra keys are forwarded as event metadata and must be
  // whitelisted server-side (Api::LogsController). This includes `page`, which
  // the backend validates against the tracking page whitelist and attaches to
  // the analytics event so exports can be segmented by where they were
  // triggered (reports, snippets, …).
  logEvent: async function(event, metadata = {}) {
    if ( !event )
      throw new Error('Event required for Log Event')

    return API.post('/api/logs', {event, ...metadata});
  }
};
